import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useGetRevenueByPlan } from "@/api/revenue/get-revenue-by-plan";
import { RevenueByPlanChart } from "./revenue-by-plan-chart";

const RevenueByPlanChartWithData = () => {
    const { data: revenueByPlanData, isLoading, isError } = useGetRevenueByPlan();

    if (isLoading) {
        return (
            <Card className="@container/card">
                <CardHeader>
                    <CardTitle>Revenue by Plan</CardTitle>
                </CardHeader>
                <CardContent className="flex items-center justify-center h-64">
                    <p>Loading revenue by plan data...</p>
                </CardContent>
            </Card>
        );
    }

    if (isError) {
        return (
            <Card className="@container/card">
                <CardHeader>
                    <CardTitle>Revenue by Plan</CardTitle>
                </CardHeader>
                <CardContent className="flex items-center justify-center h-64">
                    <p className="text-red-500">Error loading revenue by plan data</p>
                </CardContent>
            </Card>
        );
    }

    if (!revenueByPlanData || revenueByPlanData.length === 0) {
        return (
            <Card className="@container/card">
                <CardHeader>
                    <CardTitle>Revenue by Plan</CardTitle>
                </CardHeader>
                <CardContent className="flex items-center justify-center h-64">
                    <p>No revenue by plan data available</p>
                </CardContent>
            </Card>
        );
    }

    return <RevenueByPlanChart data={revenueByPlanData} />;
};

export default RevenueByPlanChartWithData;